import React, { useEffect, useState } from "react";
import {
    createWorkShift,
    updateWorkShift,
    getWorkShift,
    destroyWorkShift,
} from "../../../../../_api/WorkShift";
import { useNavigate, useParams } from "react-router-dom";
import { InputForm } from "../../../../../_helpers/components/Forms/InputLabel";
import { Button } from "../../../../../_helpers/components/Button";
import toast from "react-hot-toast";
import { DefaultDropdown } from "../../../../../_helpers/components/Forms/Dropdown";
import { Loader } from "../../../../../_helpers/components/Forms/Loader";
import { SimpleTable } from "../../../../../_helpers/components/Forms/SimpleTable";
import { intToDay } from "../../../../../_helpers/functions";
import { getDayModels } from "../../../../../_api/DayModel";
import { BackButton } from "../../../../../_helpers/components/BackButton";

const AddWorkShift = () => {
    const navigate = useNavigate();
    const opt1 = "Semaine(s)";
    const opt2 = "Jour(s)";
    const { ws_id } = useParams();
    const [name, setName] = useState("");
    const [unitWeekOrDay, setUnitWeekOrDay] = useState(opt1);
    const [numberOfUnit, setNumberOfUnit] = useState(1);
    const [isLoading, setIsLoading] = useState(true);
    const [isSaving, setIsSaving] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const [numberOfLines, setNumberOfLines] = useState(1);
    const [lines, setLines] = useState([]);
    const [dayModel, setDayModel] = useState([]);
    const [workShiftDetail, setWorkShiftDetail] = useState([]);
    const headers = ["Jour", "Horaires"];
    // const [lineSelected, setLineSelected] = useState(-1);

    const rowClick = (value) => {
        // setLineSelected(value);
    };

    const onSelect = (value) => {
        const aLine = {
            day_number: value[0],
            day_model_id: value[1],
        };
        setWorkShiftDetail([
            ...workShiftDetail.filter((a) => a.day_number != aLine.day_number),
            aLine,
        ]);
    };

    useEffect(() => { }, [workShiftDetail]);

    const loadDayModels = async () => {
        await getDayModels().then((resp) => {
            const res = resp.data.map((res) => {
                return [res.id, res.name];
            });
            setDayModel([[-1, "-- Aucun --"], ...res]);
        });
    };

    const loadWorkShift = async () => {
        setIsLoading(true);
        await loadDayModels();

        if (ws_id) {
            await getWorkShift(ws_id)
                .then((resp) => {
                    setName(resp.data.name);
                    if (resp.data.unit === "w") {
                        setUnitWeekOrDay(opt1);
                    } else {
                        setUnitWeekOrDay(opt2);
                    }
                    setNumberOfUnit(resp.data.number_of);
                    setWorkShiftDetail([...resp.data.work_shift_details]);
                })
                .catch((resp) => {
                    // Accés refusé ?
                    toast("Accès refusé.");
                    navigate("/company/time");
                });
        }
        setIsLoading(false);
    };

    useEffect(() => {
        loadWorkShift();
    }, [ws_id]);

    useEffect(() => {
        setNumberOfLines(
            unitWeekOrDay === opt1 ? numberOfUnit * 7 : numberOfUnit
        );
    }, [unitWeekOrDay, numberOfUnit]);

    useEffect(() => {
        const unit = unitWeekOrDay === opt1 ? "w" : "d";
        let week = [];

        if (unit === "w") {
            for (let i = 0; i < numberOfLines / 7; i++) {
                let listDay = [];
                for (let j = 0; j < 7; j++) {
                    const ws = workShiftDetail.find(
                        (el) => el.day_number === i * 7 + j
                    );
                    let aLine = [
                        i * 7 + j,
                        intToDay(j + 1),
                        dayModel,
                        typeof ws === "undefined" ? "" : ws.day_model_id,
                    ];
                    listDay.push(aLine);
                }
                week.push(listDay);
            }
        } else {
            let listDay = [];
            for (let i = 0; i < numberOfLines; i++) {
                const ws = workShiftDetail.find((el) => el.day_number === i);
                let aLine = [
                    i,
                    "jour " + (i + 1),
                    dayModel,
                    typeof ws === "undefined" ? "" : ws.day_model_id,
                ];
                listDay.push(aLine);
            }
            week = [listDay];
        }
        setLines(week);
    }, [numberOfLines, dayModel, workShiftDetail]);

    const addWorkShift = () => {
        const unit = unitWeekOrDay === opt1 ? "w" : "d";
        const payload = {
            name: name,
            number_of: numberOfUnit,
            unit: unit,
            work_shift_details: workShiftDetail,
        };

        setIsSaving(true);
        if (ws_id) {
            updateWorkShift(ws_id, payload).then(() => {
                toast("Modification enregistrée.");
                navigate("/company/time");
            }).catch((err) => {
                toast.error(err.response.data.message);
            }).finally(() => {
                setIsSaving(false);
            });
        } else {
            createWorkShift(payload)
                .then((request) => {
                    toast(
                        'Le cycle de travail "' + payload.name + '" a été créé.'
                    );
                    navigate("/company/time");
                })
                .catch((err) => {
                    toast.error(err.response.data.message);
                })
                .finally(() => {
                    setIsSaving(false);
                });
        }
    };

    const deleteWorkShift = () => {
        if (ws_id) {
            setIsDeleting(true);
            destroyWorkShift(ws_id).then(() => {
                toast('Le cycle de travail "' + name + '" a été supprimé.');
                navigate("/company/time");
            }).finally(() => {
                setIsDeleting(false);
            });
            return;
        }
        navigate("/company/time");
    };

    return (
        <div className="min-h-full bg-gray-50">

            {/* Header */}
            <div className="bg-white border-b border-gray-200 shadow-sm">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
                    <div className="flex items-center justify-between flex-wrap gap-4">
                        <div className="flex items-center space-x-4">
                            <BackButton
                                title="Retour"
                            />
                            <div>
                                <h1 className="text-3xl font-bold text-gray-900">
                                    {ws_id ? "Modifier" : "Ajouter"} un cycle de travail
                                </h1>
                                <p className="mt-2 text-sm text-gray-600">
                                    Les cycles permettent de définir les horaires de travail des employés.
                                </p>
                            </div>
                        </div>
                        <div className="flex flex-wrap gap-2">
                            {ws_id && (
                                <Button
                                    action={() => deleteWorkShift()}
                                    type={"red"}
                                    name={"Supprimer"}
                                    loading={isDeleting}
                                />
                            )}
                            <Button
                                action={() => {
                                    addWorkShift();
                                }}
                                name={ws_id ? "Modifier" : "Enregistrer"}
                                loading={isSaving}
                            />
                        </div>
                    </div>
                </div>
            </div>


            {isLoading ? (
                <Loader text="Recherche en cours..." />
            ) : (
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
                    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
                        <div className="flex gap-4">
                            <InputForm
                                name="Nom"
                                value={name}
                                placeholder="Nom du cycle"
                                type="text"
                                set={setName}
                                required={true}
                                classNameWrapper="w-96"
                            />

                            <div className="flex gap-4 align-text-bottom">
                                <InputForm
                                    name="Cycle sur"
                                    value={numberOfUnit}
                                    type="number"
                                    set={setNumberOfUnit}
                                    required={true}
                                    min={1}
                                    max={99}
                                    classNameWrapper="w-24"
                                />
                                <DefaultDropdown
                                    name="&nbsp;"
                                    value={unitWeekOrDay}
                                    onChange={(e) =>
                                        setUnitWeekOrDay(e.target.value)
                                    }
                                    options={[opt1, opt2]}
                                />
                            </div>
                        </div>

                        <div className="flex flex-wrap w-full mb-2">
                            {lines.map((week, index) => (
                                <SimpleTable
                                    name={
                                        unitWeekOrDay === opt1
                                            ? "Semaine " + (index + 1)
                                            : ""
                                    }
                                    headers={headers}
                                    rows={week}
                                    onClick={rowClick}
                                    onChange={onSelect}
                                    className="w-1/4 min-w-96"
                                />
                            ))}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AddWorkShift;
